import { useState } from 'react';
import { PDFViewer } from '@odo/shared-ui';
import api from '../../../../api/config';
import { RETENTION_DOCUMENTS } from '../../../../constants/retentionDocuments';

// Left pane for the Ret-5 deliver page: the two static retention documents,
// switchable via tabs and rendered through the shared PDFViewer (which proxies
// the Google Drive links via the backend pdf-proxy). Mirrors VersionedPdfPane,
// adapted for two static documents instead of one versioned document.
export function RetentionDocsPane() {
    const [activeId, setActiveId] = useState<string>(RETENTION_DOCUMENTS[0].id);
    const active = RETENTION_DOCUMENTS.find((d) => d.id === activeId) ?? RETENTION_DOCUMENTS[0];

    const docTabs = (
        <div className="flex items-center gap-1">
            {RETENTION_DOCUMENTS.map((doc) => {
                const isActive = doc.id === active.id;
                return (
                    <button
                        key={doc.id}
                        type="button"
                        onClick={() => setActiveId(doc.id)}
                        className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                            isActive
                                ? 'bg-gray-100 text-gray-900'
                                : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'
                        }`}
                    >
                        {doc.label}
                    </button>
                );
            })}
        </div>
    );

    return (
        <div className="h-full bg-white border border-gray-200 rounded-xl overflow-hidden p-3 scrollbar-hide-deep">
            <PDFViewer
                key={active.id}
                pdfUrl={active.url}
                apiBaseUrl={api.defaults.baseURL ?? ''}
                showControls
                className="h-full"
                getAuthToken={() => localStorage.getItem('odo_login_token')}
                leadingControls={docTabs}
            />
        </div>
    );
}
